import { Client } from 'urql'
import { Mutation_Root } from 'src/@types/graphql'
import { deleteHelpInstructionLinkById } from 'src/screens/administration/configuration-management/help-instructions-configuration/helpInstructionsConfigQueries'

export const deleteHelpInstruction = (urqlClient: Client) => async (helpInstructionIdToBeDeleted: number) => {
  const { data, error } = await urqlClient
    .mutation<
      {
        delete_help_and_instruction_link: Mutation_Root['delete_help_and_instruction_link']
      },
      {
        helpInstructionId: number
      }
    >(deleteHelpInstructionLinkById, {
      helpInstructionId: helpInstructionIdToBeDeleted,
    })
    .toPromise()

  if (error || data?.delete_help_and_instruction_link?.affected_rows !== 1) {
    throw new Error('Deletion error')
  }

  return true
}

const HELP_AND_INSTRUCTIONS_KEY_SEARCH_PARAM = 'helpAndInstructionsKey'

export { HELP_AND_INSTRUCTIONS_KEY_SEARCH_PARAM }
